<template>
  <section class="py-12">
    <div class="mx-auto max-w-6xl space-y-12 px-4">
      <slot />
    </div>
  </section>
</template>
